import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  alpha,
  Paper,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { Icon } from "@iconify/react";
import { FormProvider, RHFTextField } from "@app/components";
import { RenderTimeStamp } from "@app/utils";
import { RequestStatus, Strings } from "@app/constants";
import { Header } from "../types";
import { MoreVert } from "@mui/icons-material";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getrequest, deleteRequest } from "../slice";
import { selectrequestState, selectDeleterequestState } from "../selector";
import { useRequestState } from "@app/hooks";
import { request } from "@app/services";
import * as endpoints from "../endpoints";

export const Requests = () => {
  const theme = useTheme();
  const methods = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [selectedRowType, setSelectedRowType] = useState<string>(""); // New state for type
  const [selectedRowStatus, setSelectedRowStatus] = useState<string>(""); // Track status for actions
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [requestToDelete, setRequestToDelete] = useState<any>(null);
  const [page, setPage] = useState<number>(1);
  const [searchValue, setSearchValue] = useState("");
  const [selectedType, setSelectedType] = useState<string>("All");

  console.log("selectedRowType>>>", selectedRowType);

  useEffect(() => {
    // Fetch all requests once to handle client-side filtering and pagination properly
    dispatch(getrequest({ limit: 10000, page: 1, search: "" }));
  }, [dispatch]);

  const { data: allRequest, status: requestStatus } = useRequestState({
    stateSelector: selectrequestState,
    errorShown: true,
  });

  const { loading: isDeleting } = useRequestState({
    stateSelector: selectDeleterequestState,
    successMessageShown: true,
    errorShown: true,
    onSuccess: () => {
      setOpenDeleteModal(false);
      setRequestToDelete(null);
    },
  });

  console.log(allRequest, "allRequest");

  const { data: requestsArray = [] } = allRequest || {};

  useEffect(() => {
    if (requestsArray.length > 0) {
      requestsArray.forEach((request: any) => { });
    }
  }, [requestsArray]);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    id: number,
    type: string,
    status?: string,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(id);
    setSelectedRowType(type); // Store the type when menu opens
    setSelectedRowStatus(status || "");
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
    setSelectedRowType("");
    setSelectedRowStatus("");
  };

  const fontFamily = Strings.fontLanguage.workSans;
  console.log("requestsArray>>>", requestsArray);

  const uniqueTypes = [
    "All",
    ...Array.from(
      new Set(requestsArray.map((item: any) => item?.type).filter(Boolean)),
    ),
  ];

  const filteredRequests = requestsArray.filter((item: any) => {
    const searchTerm = searchValue.toLowerCase();
    const carBrand =
      `${item?.car?.brand?.name} ${item?.car?.model?.name} `?.toLowerCase() ||
      "";

    const matchesSearch =
      item?.firstName?.toLowerCase().includes(searchTerm) ||
      carBrand.includes(searchTerm) ||
      item?.type?.toLowerCase().includes(searchTerm) ||
      item?.status?.toLowerCase().includes(searchTerm) ||
      item?.requestId?.toLowerCase().includes(searchTerm) ||
      item?.date?.toLowerCase().includes(searchTerm);

    const matchesType = selectedType === "All" || item?.type === selectedType;

    return matchesSearch && matchesType;
  });

  const rowsPerPage = 10;
  const total = filteredRequests.length;
  const totalPages = Math.ceil(total / rowsPerPage) || 1;

  // Reset page if filtered results are fewer than current page index
  useEffect(() => {
    if (page > totalPages) {
      setPage(1);
    }
  }, [totalPages, page]);

  const paginatedRequests = filteredRequests.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage,
  );

  const handleExport = async () => {
    try {
      // Fetch all requests (using a large limit to get all data)
      const res: any = await request.get(
        `${endpoints.request}?search=&limit=10000&page=1`,
      );
      const allRequestsData = res?.data || [];

      // Apply the same filters to the full dataset
      const allFilteredRequests = allRequestsData.filter((item: any) => {
        const searchTerm = searchValue.toLowerCase();
        const carBrand =
          `${item?.car?.brand?.name} ${item?.car?.model?.name} `?.toLowerCase() ||
          "";

        const matchesSearch =
          item?.firstName?.toLowerCase().includes(searchTerm) ||
          carBrand.includes(searchTerm) ||
          item?.type?.toLowerCase().includes(searchTerm) ||
          item?.status?.toLowerCase().includes(searchTerm) ||
          item?.requestId?.toLowerCase().includes(searchTerm) ||
          item?.date?.toLowerCase().includes(searchTerm);

        const matchesType =
          selectedType === "All" || item?.type === selectedType;

        return matchesSearch && matchesType;
      });

      if (allFilteredRequests.length === 0) {
        alert("No data to export");
        return;
      }

      const headers = [
        "Request Id",
        "Customer Name",
        "Email",
        "Phone Number",
        "State",
        "City",
        "Zip Code",
        "Car Model",
        "Type",
        "Date",
        "Status",
      ];
      const csvRows = [headers.join(",")];

      allFilteredRequests.forEach((item: any) => {
        const requestId = item.requestId || "N/A";
        const customerName =
          [(item.firstName || item?.user?.firstName), (item.lastName || item?.user?.lastName)].filter(Boolean).join(" ") || "N/A";

        let email = item.email || item.user?.email || "N/A";
        if (typeof email === "object") email = JSON.stringify(email);

        let phone =
          item.phone ||
          item.phoneNumber ||
          item.user?.phone ||
          item.mobile ||
          "N/A";
        if (typeof phone === "object") phone = JSON.stringify(phone);

        const carModel =
          item.car?.brand?.name && item.car?.model?.name
            ? `${item.car.brand.name} ${item.car.model.name}`
            : "N/A";
        const type = item.type || "N/A";

        let date = "N/A";
        if (item.date) {
          date = item.date + (item.time ? " " + item.time : "");
        } else if (item.createdAt) {
          date = item.createdAt;
        }

        const status = item.status || "N/A";

        // Prepend tab for phone to prevent Excel from converting to scientific notation
        const formattedPhone = phone !== "N/A" ? `\t${phone}` : phone;
        const city = item?.city || "N/A";
        const state = item?.state || "N/A";
        const zipCode = item?.zipCode || "N/A";
        const row = [
          requestId,
          customerName,
          email,
          formattedPhone,
          state,
          city,
          zipCode,
          carModel,
          type,
          date,
          status,
        ]
          .map((value) => `"${String(value).replace(/"/g, '""')}"`)
          .join(",");
        csvRows.push(row);
      });

      const csvContent =
        "data:text/csv;charset=utf-8," + encodeURIComponent(csvRows.join("\n"));
      const link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute(
        "download",
        `requests_${selectedType.toLowerCase()}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Failed to export data");
    }
  };

  return (
    <FormProvider methods={methods}>
      <Box
        sx={{
          p: 3,
          backgroundColor: "#fff",
          borderRadius: 1,
          minHeight: { xs: "auto", md: "calc(100vh - 64px)" },
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="space-between"
          mb={3}
          alignItems="center"
        >
          <RHFTextField
            size="medium"
            placeholder="Search"
            fullWidth
            name="Search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value.toLowerCase())}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon icon="mdi:magnify" fontSize={30} />
                </InputAdornment>
              ),
            }}
          />
          <Stack direction="row" spacing={2} alignItems="center">
            <TextField
              select
              size="medium"
              label="Type"
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              sx={{ minWidth: 200 }}
            >
              {uniqueTypes.map((type) => (
                <MenuItem key={type as string} value={type as string}>
                  {type as string}
                </MenuItem>
              ))}
            </TextField>
            <Button
              variant="contained"
              color="primary"
              onClick={handleExport}
              sx={{ height: 53 }}
            >
              Export
            </Button>
          </Stack>
        </Stack>

        <TableContainer sx={{ border: "1px solid #E0E0E0", borderRadius: 1 }}>
          <Table>
            <TableHead>
              <TableRow>
                {Header.map((heading) => (
                  <TableCell
                    align="center"
                    key={heading}
                    sx={{
                      fontWeight: 600,
                      fontFamily,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {requestStatus === RequestStatus.RUNNING ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Loading...
                  </TableCell>
                </TableRow>
              ) : paginatedRequests.length > 0 ? (
                paginatedRequests.map((item: any, index: number) => (
                  <TableRow
                    key={index}
                    hover // <--- CHANGE: Added hover effect
                    sx={{ cursor: "pointer" }} // <--- CHANGE: Added pointer cursor
                    onClick={() => {
                      // <--- CHANGE: Added onClick handler
                      // NOTE: Make sure PATH_DASHBOARD.requests is defined in your paths file
                      navigate(`${PATH_DASHBOARD.requests}/${item.id}`);
                    }}
                  >
                    <TableCell align="center">
                      {item.requestId ?? "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {item?.firstName || item?.user?.firstName} {item?.lastName || item?.user?.lastName}
                    </TableCell>
                    <TableCell align="center">
                      {item.car?.brand?.name && item.car?.model?.name
                        ? `${item.car.brand.name} ${item.car.model.name}`
                        : "N/A"}
                    </TableCell>
                    <TableCell align="center">{item.type ?? "N/A"}</TableCell>
                    <TableCell align="center">
                      {item?.date
                        ? RenderTimeStamp(item.date + " " + item.time)
                        : RenderTimeStamp(item.createdAt)}
                    </TableCell>
                    <TableCell align="center">
                      <Box
                        sx={{
                          display: "inline-block",
                          px: 1.5,
                          py: 1,
                          borderRadius: 1,
                          fontWeight: 600,
                          fontSize: 14,
                          ...(item.status === "Pending" && {
                            backgroundColor: theme.palette.warning.lighter,
                            color: theme.palette.warning.main,
                          }),
                          ...(item.status === "Assigned" && {
                            backgroundColor: theme.palette.success.lighter,
                            color: theme.palette.success.main,
                          }),
                          ...(item.status === "Rejected" && {
                            backgroundColor: theme.palette.error.lighter,
                            color: theme.palette.error.main,
                          }),
                        }}
                      >
                        {item.status}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation(); // <--- CHANGE: IMPORTANT! Prevents row click
                          handleMenuOpen(e, item.id, item.type, item.status);
                        }}
                      >
                        <MoreVert />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No requests found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack
          direction="row"
          justifyContent="flex-end"
          mt={2}
          alignItems={"center"}
          height={"auto"}
          gap={2}
        >
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 500 }}
          >
            {(() => {
              if (total === 0) return "Showing 0 to 0 of 0 Requests";

              const start = (page - 1) * rowsPerPage + 1;
              const end = Math.min(page * rowsPerPage, total);

              return `Showing ${start} to ${end} of ${total} Requests`;
            })()}
          </Typography>

          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
          />
          <TextField
            name="pagination"
            type="number"
            value={page}
            size="small"
            sx={{
              width: 60,
            }}
            onChange={(e) =>
              setPage(() => {
                const val = Number(e.target.value);
                if (val <= totalPages) {
                  return val > 0 ? val : 1;
                }
                return 1;
              })
            }
          />
        </Stack>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {/* Show other actions only if status is NOT completed */}
        {selectedRowStatus?.toLowerCase() !== "completed" && (
          <>
            {/* ✅ For BUY type */}
            {selectedRowType?.toLowerCase() === "buy" && (
              <>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate(PATH_DASHBOARD.changeStatus, {
                      state: { requestId: selectedRow },
                    });
                  }}
                >
                  {Strings.button.changeStatus}
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate(PATH_DASHBOARD.assignSalesPerson, {
                      state: { requestId: selectedRow },
                    });
                  }}
                >
                  {Strings.button.salesPerson}
                </MenuItem>
              </>
            )}
            {/* ✅ For BUY type */}
            {selectedRowType?.toLowerCase() === "test drive" && (
              <>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate(PATH_DASHBOARD.changeStatus, {
                      state: { requestId: selectedRow },
                    });
                  }}
                >
                  {Strings.button.changeStatus}
                </MenuItem>
              </>
            )}

            {(selectedRowType?.toLowerCase() === "sell" ||
              selectedRowType?.toLowerCase() === "car evaluation") && (
                <>
                  <MenuItem
                    onClick={() => {
                      handleMenuClose();
                      navigate(PATH_DASHBOARD.addValuation, {
                        state: { requestId: selectedRow },
                      });
                    }}
                  >
                    {Strings.button.valuation}
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      handleMenuClose();
                      navigate(PATH_DASHBOARD.assignAgent, {
                        state: { requestId: selectedRow },
                      });
                    }}
                  >
                    {Strings.product.assignAgent}
                  </MenuItem>
                </>
              )}
          </>
        )}

        {/* Delete Request for all request types (and ONLY action for completed status) */}
        <MenuItem
          onClick={() => {
            handleMenuClose();
            const rowData = paginatedRequests.find(
              (item: any) => item.id === selectedRow
            );
            setRequestToDelete(rowData || { id: selectedRow });
            setOpenDeleteModal(true);
          }}
          sx={{ color: "error.main" }}
        >
          {Strings.button.delete}
        </MenuItem>
      </Menu>

      {/* ------------------------------------------------------------- */}
      {/* DELETE REQUEST CONFIRMATION POPUP */}
      {/* ------------------------------------------------------------- */}
      <Dialog
        open={openDeleteModal}
        onClose={() => !isDeleting && setOpenDeleteModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 1,
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#101828",
              }}
            >
              Delete Request
            </Typography>
            <IconButton
              disabled={isDeleting}
              onClick={() => {
                setOpenDeleteModal(false);
                setRequestToDelete(null);
              }}
              size="small"
              sx={{ color: theme.palette.grey[500] }}
            >
              <Icon icon="mdi:close" style={{ fontSize: 20 }} />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ pt: 1 }}>
          <DialogContentText
            sx={{
              mb: 2,
              fontFamily,
              color: "#474747",
              fontSize: "0.9rem",
              lineHeight: 1.5,
            }}
          >
            Are you sure you want to delete this request? This action cannot be undone.
          </DialogContentText>

          {requestToDelete && (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                backgroundColor: theme.palette.grey[50],
                border: `1px solid #E0E0E0`,
              }}
            >
              <Stack spacing={1.2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                    Request ID:
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily, color: "#101828", fontWeight: 600 }}>
                    {requestToDelete.requestId || `#${requestToDelete.id}`}
                  </Typography>
                </Stack>
                {(requestToDelete.firstName || requestToDelete.lastName || requestToDelete.user) && (
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                      Customer Name:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily, color: "#101828", fontWeight: 600 }}>
                      {[
                        requestToDelete?.user?.firstName || requestToDelete?.firstName,
                        requestToDelete?.user?.lastName || requestToDelete?.lastName,
                      ]
                        .filter(Boolean)
                        .join(" ") || "N/A"}
                    </Typography>
                  </Stack>
                )}
                {requestToDelete?.car && (
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                      Car Model:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily, color: "#101828", fontWeight: 600 }}>
                      {`${requestToDelete.car.brand?.name || ""} ${requestToDelete.car.model?.name || ""}`.trim() ||
                        "N/A"}
                    </Typography>
                  </Stack>
                )}
                {requestToDelete?.type && (
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                      Request Type:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily, color: "#101828", fontWeight: 600 }}>
                      {requestToDelete.type}
                    </Typography>
                  </Stack>
                )}
                {requestToDelete?.status && (
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                      Status:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontFamily,
                        color: theme.palette.primary.main,
                        fontWeight: 700,
                      }}
                    >
                      {requestToDelete.status}
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Paper>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1.5 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenDeleteModal(false);
              setRequestToDelete(null);
            }}
            disabled={isDeleting}
            sx={{
              flex: 1,
              borderRadius: 1,
              textTransform: "none",
              fontFamily,
              fontWeight: 600,
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              "&:hover": {
                borderColor: theme.palette.primary.dark,
                backgroundColor: alpha(theme.palette.primary.main, 0.04),
              },
            }}
          >
            {Strings.button.cancel}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (requestToDelete?.id) {
                dispatch(deleteRequest({ id: requestToDelete.id }));
              }
            }}
            disabled={isDeleting}
            startIcon={
              isDeleting ? (
                <CircularProgress size={16} color="inherit" />
              ) : null
            }
            sx={{
              flex: 1,
              borderRadius: 1,
              textTransform: "none",
              fontFamily,
              fontWeight: 600,
              backgroundColor: theme.palette.primary.main,
              color: "white",
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            {isDeleting ? "Deleting..." : Strings.button.delete}
          </Button>
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
};
